export default "__VITE_ASSET__V0mp90hy__"